import { render, staticRenderFns } from "./IncomeOtherPersonHouseholdFSSurvey.vue?vue&type=template&id=11df2621"
import script from "./IncomeOtherPersonHouseholdFSSurvey.vue?vue&type=script&lang=ts"
export * from "./IncomeOtherPersonHouseholdFSSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports